import request from '@/utils/request' //引入封装好的 axios 请求

// 获取审核列表
export function queryAuth (data = {}) {
    return request({
        url: '/api/v1/auth/queryAuth',
        method: 'post',
        data: data
    })
}

// 审核 通过或不通过
export function updateAuth (data = {}) {
    return request({
        url: '/api/v1/auth/mod',
        method: 'post',
        data: data
    })
}


// 审核 通过或不通过
export function List (data = {}) {
    return request({
        url: 'api/credit/user/list',
        method: 'post',
        data: data
    })
}

//修改授权
export function operateexport (data = {}) {
    return request({
        url: '/api/credit/user/operate ',
        method: 'post',
        data: data
    })
}


//修改授权
export function selectByCode (id) {
    return request({
        url: `/api/credit/dictionary/selectByCode?code=${id}`,
        method: 'post',
        data: {}
    })
}